export const toolbarLabel = "jSa";
export const singleLineRibbonLabel = "kSa";
export const multiLineRibbonLabel = "lSa";
export const layoutHeaderLabel = "mSa";
export const ribbonLayoutButtonLabel = "nSa";
export const ribbonDisplayOptionsLabel = "oSa";
export const showTabsOnly = "pSa";
export const showTabsAndButtons = "qSa";
export default {toolbarLabel,singleLineRibbonLabel,multiLineRibbonLabel,layoutHeaderLabel,ribbonLayoutButtonLabel,ribbonDisplayOptionsLabel,showTabsOnly,showTabsAndButtons};